const walkthroughIds = {
    ufSiteName: 'site-management/uf-site-name',
    ufAddress: 'site-management/uf-address',
    ufPbx: 'site-management/uf-pbx',
    ufSiteCode: 'site-management/uf-site-code',
    ufExtensionLength: 'site-management/uf-extension-length',
    ufLanguage: 'site-management/uf-language',
    ufTimeZone: 'site-management/uf-time-zone',
    ufVoicemailDestination: 'site-management/uf-voicemail-destination',
    ufMainLineNumber: 'site-management/uf-main-line-number',
    ufSetMainNumberAsCallerId: 'site-management/uf-set-main-number-caller-id',
    ufShareMainNumberAsCallerId:
        'site-management/uf-share-main-number-caller-id',
    ufCallingCountry: 'site-management/uf-calling-country',
    ufBackBtn: 'site-management/uf-back-btn',
    ufCreateBtn: 'site-management/uf-create-btn',
    ufEditBtn: 'site-management/uf-edit-btn',
    ufDeleteBtn: 'site-management/uf-delete-btn',
    ufAddSiteBtn: 'site-management/uf-add-site-btn',
};

export default walkthroughIds;
